import call1 from "../../assets/images/call1.webp";
import send from "../../assets/images/send.svg";

import start_rating from "../../assets/images/start_rating.webp";
import user_switch from "../../assets/images/user_switch.svg";
import arrow_up from "../../assets/images/arrow_up.svg";
import crown from "../../assets/images/crown.svg";
import banner_lg from "../../assets/images/banner_lg.webp";
import bannerlg from "../../assets/images/bannerlg.webp";
import bannermo from "../../assets/images/bannermo.webp";
export default function Banner() {
  return (
    <div className="w-full bg-center bg-cover bg-no-repeat bg-[url('./assets/images/bannermo.webp')] md:bg-[url('./assets/images/bannerlg.webp')]">
      <div className="w-full mx-auto p-3 bg-cover bg-center bg-no-repeat container mt-20 lg:mt-[104px]">
        <div className="p-1 grid grid-cols-1 gap-4 items-center lg:grid-cols-2 w-full lg:px-6">
          <div className="h-auto flex flex-col gap-4 lg:gap-6 p-2 text-white relative lg:left-[70px]">
            <div className="w-full max-w-md lg:max-w-[45rem]">
              <p className="text-sm md:text-base font-normal">
                CHÀO MỪNG BẠN ĐẾN VỚI BLUESKYIT
              </p>
            </div>
            <div className="w-full max-w-md md:max-w-full lg:max-w-[40rem] text-xl sm:text-2xl font-medium leading-7 sm:leading-9 lg:text-4xl lg:font-medium lg:leading-[3rem]">
              <p>BlueskyIT – Kết nối giải pháp cho tương lai</p>
            </div>
            <div className="w-full max-w-md md:max-w-full text-sm sm:text-base lg:text-lg lg:font-normal font-semibold lg:whitespace-nowrap leading-7">
              <p>
                Chúng tôi cung cấp những giải pháp đột phá trong giáo dục, sức
                khỏe và đào tạo
              </p>
            </div>
            <div className="flex flex-col items-center md:flex-row md:items-center justify-center gap-4">
              <div className="flex items-center w-full max-w-md">
                <a href="contact-us" className="w-full">
                  <button className="bg-white border border-white flex items-center shadow-custom rounded-[30px] gap-3 justify-center w-full max-w-xs h-12 hover:shadow-lg transition-shadow">
                    <img src={call1} alt="call1" className="w-5 h-5" />
                    <p className="text-[#1375b7] font-medium text-base lg:text-lg whitespace-nowrap">
                      Liên hệ tư vấn ngay
                    </p>
                  </button>
                </a>

                <div className="border border-white w-12 h-12 bg-white flex items-center justify-center rounded-full ml-2 flex-shrink-0">
                  <img src={send} alt="send" className="w-5 h-5" />
                </div>
              </div>

              <div className="flex flex-col w-full max-w-md justify-center lg:flex-col lg:items-start lg:text-left lg:gap-2 items-center">
                <img src={start_rating} alt="rate" className="w-28 h-auto" />
                <p className="text-sm md:text-base font-normal">
                  2960+ đánh giá từ khách hàng
                </p>
              </div>
            </div>
          </div>

          {/* banner2 */}

          <div className="relative flex flex-col items-center gap-4 lg:bottom-[-4px] lg:left-[110px]">
            {/*  */}

            <div className="flex items-center justify-around shadow-custom1 w-full max-w-sm h-[59px] p-2 lg:absolute lg:bottom-[245px] lg:-left-[-30px] bg-white rounded-[36px] lg:w-[14.8125rem] lg:z-20 animate-bounce">
              <div className="flex lg:items-start justify-center flex-col">
                <p className="text-[#073C7A] text-xl md:text-2xl font-normal lg:font-semibold">
                  68K+
                </p>
                <p className="text-xs md:text-sm font-normal text-[#333]">
                  Khách hàng hài lòng
                </p>
              </div>
              <div className="bg-[#3DB72D] w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0">
                <img src={user_switch} alt="user" className="w-6 h-6" />
              </div>
            </div>
            {/*  */}
            {/*  */}

            {/*  */}
            {/*  */}
            <div className="flex items-center justify-around shadow-custom1 lg:absolute lg:bottom-[40px] lg:right-[270px] p-2 w-full max-w-[270px] h-[57px] bg-white rounded-[36px] lg:w-[15.8125rem] lg:z-20 animate-bounce">
              <div className="bg-[#4CA8FF] w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0">
                <img src={crown} alt="crown" className="w-6 h-6" />
              </div>
              <div className="flex items-center justify-center flex-col gap-1">
                <p className="text-[#073C7A] text-xs md:text-sm font-normal">
                  Giá trị doanh nghiệp
                </p>
                <p className="text-xl md:text-2xl font-normal text-[#073C7A] flex lg:font-semibold">
                  1.000.000${" "}
                  <img
                    src={arrow_up}
                    alt="arrow_up"
                    className="animate-bounce w-5 h-5"
                  />
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center shadow-custom1 w-full max-w-[170px] lg:absolute lg:bottom-[160px] lg:-right-[-85px] h-[57px] px-6 py-2 bg-white rounded-[36px] lg:z-20 lg:w-[10.1875rem] animate-bounce">
              <div className="flex items-center justify-center flex-col w-full">
                <p className="text-xs md:text-sm font-normal text-[#333]">
                  Tỉ lệ thành công
                </p>
                <p className="text-[#073C7A] text-xl md:text-2xl font-normal lg:font-semibold">
                  96%
                </p>
              </div>
            </div>
            <div className="w-full flex justify-center">
              <img
                src={banner_lg}
                alt="ban"
                className="max-w-full h-auto relative bottom-[20px] lg:max-w-full lg:w-[333.965px] lg:h-[415.894px]"
              />
            </div>
            {/*  */}
          </div>

          {/* banner2 */}
        </div>
      </div>
    </div>
  );
}
